import Vue from 'vue'
import axios from 'axios'
import { Notification } from '@jd/element-ui'
import { isNull } from '@/utils'
import Cookies from 'js-cookie'
import getTranslation from '@/i18n/getTranslation'
// import {LINK} from ''
const service = axios.create({
  timeout: 20000,
  baseURL: window.__INJECTED_PUBLIC_PATH_BY_QIANKUN__ || '',
  withCredentials: true
})
// loading 组
let ARR_LOADING = []
let IS_LOADING = false
let LOADING_INSTANCE = null

service.interceptors.request.use(config => {
  if (config.isLoading) {
    ARR_LOADING.push(config.url)
    if (!IS_LOADING) {
      IS_LOADING = true
      let loadingConfig = {
        text: ''
      }
      if (config.target) {
        loadingConfig.target = config.target
      }
      LOADING_INSTANCE = Vue.$loading(loadingConfig)
    }
  }
  if (config.isCsrf && Cookies.get('csrfToken')) {
    Object.assign(config.headers, {
      'x-csrf-token': Cookies.get('csrfToken')
    })
  }
  return config
})
service.interceptors.response.use(
  response => {
    let {
      data: { code, success, message, data },
      config
    } = response
    if (config.isLoading) {
      let index = ARR_LOADING.indexOf(config.url)
      ARR_LOADING.splice(index, 1)
      if (ARR_LOADING.length === 0) {
        LOADING_INSTANCE.close()
        LOADING_INSTANCE = null
        IS_LOADING = false
      }
    }
    // 如果不是code 返回值
    if (isNull(code) && isNull(success)) {
      return response.data
    }
    // 未登录判断
    if (code === 90001) {
      window.location.replace(
        '//uc.jcloud.com/redirect/quit?returnUrl=' +
          escape(window.location.href)
      )
    }
    // 未激活判断
    if (code === 90002) {
      let _returnUrl = window.location.href
      if (
        !_returnUrl.includes('complet') &&
        !_returnUrl.includes('account-activation')
      ) {
        window.location.replace(
          `${
            window.serverConfig.consoleUrl.uc
          }/passport/account-activation?returnUrl=${escape(_returnUrl)}`
        )
      }
    }
    if ((code && code !== 0) || success === false) {
      // 是否自动提示消息
      if (config.isOutMsg) {
        Notification({
          type: 'error',
          message: getTranslation(
            message || '出错啦_请确认网络是否正常_稍后再试'
          )
        })
      }
      return Promise.reject({ code, data, message: getTranslation(message) }) // eslint-disable-line
    } else {
      return {
        body: response.data
      }
    }
  },
  error => {
    ARR_LOADING = []
    if (LOADING_INSTANCE) {
      LOADING_INSTANCE.close()
      LOADING_INSTANCE = null
    }
    IS_LOADING = false
    const {
      response: { status, data }
    } = error
    console.error(error)
    if (status === 401) {
      if (error.response.data && error.response.data.loginUrl) {
        window.location.href = `${decodeURIComponent(
          error.response.data.loginUrl
        )}?returnUrl=${encodeURIComponent(window.location.href)}`
      }
      return Promise.reject(error)
    }
    if (status === 402) {
      window.location.href =
        derivativeConfig.active + encodeURIComponent(window.location.href)
      return
    }
    if (status === 403) {
      Notification.error({
        title: '您没有权限执行此操作，请联系管理员为您添加权限。',
        message: getTranslation(data.message),
        duration: 10000
      })
      return
    }
    Notification({
      type: 'error',
      message: data
        ? getTranslation(data.message)
        : getTranslation('出错啦_请确认网络是否正常_稍后再试')
    })
    return Promise.reject(error)
  }
)
export default service
